import { css, styled } from 'styled-components';

import { ButtonOrLink } from '#/components/ButtonOrLink/ButtonOrLink';
import {
  colors,
  cssBreakpoints,
  fontSizes,
  gutterWidth,
  headingSmallText,
  spacing,
  transition,
} from '#/theme/theme';

export const layoutHeaderPanelIconSlotWidth = 24;

export const LayoutHeaderPanelHolder = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 101;
  overflow-y: scroll;
  background: ${colors.white};
  box-shadow: -2px 0 4px rgb(0 0 0 / 0.1);

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: none;
  }
`;

export const LayoutHeaderPanelHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: sticky;
  top: 0;
  z-index: 1;
  height: 60px;
  padding: 0 ${gutterWidth / 2}px;
  border-bottom: 1px solid ${colors.selectionGrey};
  /* Sticky, so it needs a background or the rows show through on scroll */
  background: ${colors.white};
`;

export const LayoutHeaderPanelBody = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: ${spacing[24]};
`;

export const LayoutHeaderPanelSectionTitle = styled.h2`
  ${headingSmallText};
  color: ${colors.lightContentGrey};
  margin: 0;
  padding: ${spacing[16]} ${gutterWidth / 2}px ${spacing[8]};
`;

export const LayoutHeaderPanelRowsHolder = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const layoutHeaderPanelRowCss = css`
  display: flex;
  align-items: center;
  gap: ${spacing[12]};
  width: 100%;
  min-height: 52px;
  padding: 0 ${gutterWidth / 2}px;
  color: ${colors.mediumContentGrey};
  font-size: ${fontSizes[16]};
  font-weight: normal;
  text-align: left;
  text-decoration: none;
  transition: ${transition};
  transition-property: color, background-color;

  &:hover,
  &:focus-visible {
    color: ${colors.brandBlue};
    /* Translucent so it also reads on tinted backgrounds, e.g. the org card */
    background-color: rgb(0 0 0 / 5.5%);
    text-decoration: none;
  }
`;

export const LayoutHeaderPanelLink = styled(ButtonOrLink)`
  ${layoutHeaderPanelRowCss};
`;

export const LayoutHeaderPanelLogoutLink = styled(LayoutHeaderPanelLink)`
  color: ${colors.alertRed};

  &:hover,
  &:focus-visible {
    color: ${colors.alertRedHover};
  }
`;
